import React, { Component, PropTypes } from 'react';
import { findDOMNode } from 'react-dom';
import Icon from '../tc-ui/icon';
import $ from 'jquery';
import Card from '../tc-ui/card';
import languagesObj from '../../localization/languages.json';
const languageSettings = languagesObj['en-US'];
import CropDialog from '../tc-ui/image-crop/image-crop-dialog';

class OnBoardingImage extends Component {

  componentDidMount() {
    if (this.props.src) this._loadAndResize();
  }

  componentDidUpdate() {
    this._loadAndResize();
  }

  _removeImage = () => {
    this._imageSrcChanged(null);
    $.get('/proxy/profileImage')
      .fail((error) => {
        console.log(error);
      });
  };

  _imageSrcChanged = (publicUrl) => {
    this._toggleLoader(false);
    this.props.giveUrl(publicUrl);
  };

  _loadAndResize = () => {
    // TO DO - get rid of jQuery;
    const resizeCss = function (wrapper) {
      let margin;
      if (this.width > this.height) {
        wrapper.css({ width: '100%', height: 'auto' });
        margin = (256 - this.height) / 2;
        wrapper.css({ 'margin-top': margin, 'margin-bottom': margin });
      } else {
        wrapper.css({ width: 'auto', height: '100%' });
        margin = (256 - this.width) / 2;
        wrapper.css({ 'margin-left': margin, 'margin-right': margin });
      }
    };
    $('#profileImage').load(function () {
      resizeCss.call(this, $('#profileImage'));
    });
    $('#profileImageBackground').load(function () {
      resizeCss.call(this, $('#profileImageBackground'));
    });
  };

  _toggleLoader = (shouldToggle) => {
    findDOMNode(this.refs.profileLoader).classList.toggle('loader', shouldToggle);
  };

  render() {
    const img = (() => {
      if (this.props.src) return <img id="profileImage" src={this.props.src}/>;
      return <Icon className="tc-icon-office" />;
    })();

    const deleteIcon = this.props.src ? <Icon className="tc-icon-delete onboarding-delete" onClick={this._removeImage}/> : undefined;

    const logoStub = (
      <div className="onboarding-image-background">
        <Icon className="tc-icon-office" />
      </div>
    );
    const logoReal = (
      <div id="profileViewImage" className="profileViewImage" style={{
        backgroundImage: `url("${this.props.src}")` }}
      />
    );

    return (
      <Card
        className="on-boarding-card"
        title={languageSettings.onboarding.companyLogo}
        subtitle={languageSettings.onboarding.optional}
      >

        <div className="l-paper-split-form image">
          <div className="l-paper-left">
            <div ref="profileLoader" className="onboarding-image-container">
              {this.props.src ? logoReal : logoStub}
            </div>
            {deleteIcon}
          </div>
          <div className="l-paper-right">
            <p>{languageSettings.onboarding.logoParagraph}</p>
              <div style={{
                position: 'absolute',
                left: '25%',
                marginTop: '40px',
                width: '50%',
              }}
              >
                <CropDialog
                  confirmCroppedFn={this._imageSrcChanged}
                  uploadStartFn={() => {
                    if (this.props.src) {
                      this._removeImage();
                      this._toggleLoader.bind(this, true);
                    }
                    this._toggleLoader.bind(this, true);
                  }}
                  cropWidth={256}
                  cropHeight={256}
                  imageName="profile"
                  dialogWidth="400px"
                  round
                >
                  <div style={{
                    backgroundColor: 'rgb(0, 188, 212)',
                    color: '#FFFFFF',
                    textAlign: 'center',
                    padding: '5px',
                    borderRadius: '3px',
                  }}
                  >
                    CHOOSE AN IMAGE
                  </div>
                </CropDialog>
              </div>
          </div>
        </div>
      </Card>

    );
  }
}

OnBoardingImage.propTypes = {
  src: PropTypes.string,
  imageSrcChanged: PropTypes.func,
  giveUrl: PropTypes.func,
};

export default OnBoardingImage;



// WEBPACK FOOTER //
// ./src/app/components/onboarding/on-boarding-profile-image.jsx